.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

.muted {
  color: var(--text-3);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  background: var(--error-bg);
  color: var(--error);
  box-shadow: var(--glow-error);
  font-size: var(--fs-sm);
}

.subtitle {
  margin: 0;
  font-size: var(--fs-md);
  font-weight: 600;
}

.switchRow {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-weight: 500;
}

.keyBlock {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
}

.keyStatus {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-2);
}

.keyRow {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

/* Подпись кнопки в одну строку: рядом с полем во всю ширину она иначе
   ломается пополам и выглядит выше самого поля. */
.keyRow button {
  white-space: nowrap;
}

.keyRow .input {
  flex: 1;
}

/* Источники идут секциями сверху вниз, каждая во всю ширину.
   Рядом они стояли узкими колонками, и в 280 пикселей не помещалось главное —
   строка модели: у провайдера это 'google/gemini-2.5-flash-preview' плюс цена
   и контекст. Настройка у каждого источника своя, и читать её надо целиком. */
.sources {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

/* Внутри секции — подпись слева, органы управления справа: так три секции
   читаются одним столбцом заголовков, а не тремя разными формами. */
.sourceCard {
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);
  gap: var(--sp-3) var(--sp-6);
  align-items: start;
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
}

.sourceHead {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  grid-row: span 2;
}

/* Требования к модели магии: отдельный блок во всю ширину под карточками
   источников, свёрнутый. Так же свёрнуты шаблоны и частые блоки в библиотеке —
   справка, к которой возвращаются редко, не должна занимать высоту постоянно. */
.reqBlock {
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.reqSummary {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
}

.reqBlock[open] .reqSummary {
  margin-bottom: var(--sp-3);
}

.reqBlock .hint {
  margin-top: var(--sp-3);
}

.reqList {
  margin: 0;
  padding-left: var(--sp-5);
  color: var(--text-3);
  font-size: var(--fs-sm);
  list-style: disc;
}

.reqList li + li {
  margin-top: var(--sp-1);
}

/* Свои настройки задачи — под выбором модели, свёрнутые. */
.tune {
  margin-top: var(--sp-4);
}

.tuneSummary {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
}

.tuneGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: var(--sp-4);
  margin: var(--sp-3) 0;
}

/* Строка под полем: что унаследовано, а что задано вручную. Место под неё
   занято всегда — иначе сетка дёргается по высоте при вводе. */
.inherited {
  margin: var(--sp-1) 0 0;
  color: var(--text-3);
  font-size: var(--fs-xs);
  min-height: 1.2em;
}

.sourceBody {
  min-width: 0;
}

.sourceCard .testRow {
  grid-column: 2;
}

/* Узкий экран: подпись возвращается над полями — две колонки здесь не живут. */
@media (max-width: 720px) {
  .sourceCard {
    grid-template-columns: minmax(0, 1fr);
  }

  .sourceHead {
    grid-row: auto;
  }

  .sourceCard .testRow {
    grid-column: 1;
  }
}

.testRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-3);
}

.testOk {
  color: var(--ok);
  font-size: var(--fs-sm);
}

.testFailed {
  color: var(--error);
  font-size: var(--fs-sm);
}

.modelsBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-4);
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.advanced {
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.advancedGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--sp-4);
  margin-top: var(--sp-4);
}

.field {
  display: flex;
  flex-direction: column;
}

.saveBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-4);
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.updated {
  margin-left: auto;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

/* Подборка моделей под задачу. Стоит между выбором модели и свёрнутыми
   настройками: её читают ровно в тот момент, когда открыли список моделей и
   не знают, что из четырёхсот вариантов брать. */
.recommend {
  margin-top: var(--sp-4);
}

.recommendTitle {
  margin: 0 0 var(--sp-2);
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
}

.recommendList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin: 0 0 var(--sp-2);
  padding: 0;
  list-style: none;
}

/* Кнопка, а не строка списка: подставить id одним нажатием — то, ради чего
   подборку и читают. Выбранная сейчас модель подсвечена, чтобы было видно,
   стоит ли уже что-то из рекомендованного. */
.recommendItem {
  display: flex;
  align-items: baseline;
  gap: var(--sp-2);
  padding: var(--sp-1) var(--sp-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface-2);
  color: var(--text-2);
  font-size: var(--fs-xs);
  cursor: pointer;
}

/* Обводка, а не заливка: чипов в ряду пять, и пять залитых плашек спорили бы
   за внимание с самим выбором модели над ними. --accent в палитрах нет —
   акценты в этой теме приглушённые, и роль «выделено» играет --border-strong. */
.recommendItem:hover {
  border-color: var(--border-strong);
  color: var(--text);
}

.recommendItem[aria-pressed='true'] {
  border-color: var(--border-strong);
  color: var(--text);
  font-weight: 600;
}

.recommendId {
  font-family: var(--font-mono, ui-monospace, monospace);
}

.recommendPrice {
  color: var(--text-3);
  white-space: nowrap;
}

/* Претензия к выбранной модели: не ошибка формы (та красная и запрещает
   сохранение), а предупреждение о том, что задача с этой моделью работать не
   станет. Сохранить такой выбор можно — вдруг модель появится позже. */
.issue {
  margin: var(--sp-3) 0 0;
  padding: var(--sp-2) var(--sp-3);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  background: var(--warn-bg);
  color: var(--warn);
  font-size: var(--fs-sm);
}

.tuneRecommend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
  margin-bottom: var(--sp-3);
}

/* Возможности модели в чипе подборки: те же слова, что и бейджами в списке
   моделей, но без рамок — пять обведённых плашек внутри обведённого чипа
   превратили бы ряд в кашу. */
.recommendBadges {
  display: flex;
  gap: var(--sp-2);
  color: var(--text-3);
}

.recommendBadges span::before {
  content: '· ';
}
